import React from 'react';

import { LoginBlock, BackgroundSection } from '@zapier/product-get-help';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { useFormContext } from 'app/get-help/contexts/FormContext';
import {
  EVENT_CONTACT_LOG_IN,
  EVENT_CONTACT_SIGN_UP,
} from 'app/get-help/constants';

const Login = () => {
  const {
    size,
    account,
    showLoginComponent,
    setShowLoginComponent,
  } = useFormContext();
  const { trackEvent } = useTrackingContext();

  const onClickLogIn = () => {
    trackEvent(EVENT_CONTACT_LOG_IN);
    trackEvent(
      'schema:web_analytics.tracking.user_interaction.UserInteractionEvent',
      {
        system_name: 'support_contact_form',
        interaction_name: 'user_login',
        option_selected: 'Log In',
        interaction_raw_text: 'Log In',
        interaction_goal: 'user login',
        event_action: 'click',
      }
    );
  };

  const onClickSignUp = () => {
    trackEvent(EVENT_CONTACT_SIGN_UP, {
      loggedIn: false,
    });
    trackEvent(
      'schema:web_analytics.tracking.user_interaction.UserInteractionEvent',
      {
        system_name: 'support_contact_form',
        interaction_name: 'user_signup',
        option_selected: 'Sign Up',
        interaction_raw_text: 'Sign Up',
        interaction_goal: 'user signup',
        event_action: 'click',
      }
    );
  };

  const onClickContinue = () => {
    setShowLoginComponent(false);
  };

  return (
    <React.Fragment>
      {!account && showLoginComponent && (
        <BackgroundSection
          containerPaddingBottom={40}
          containerPaddingTop={60}
          height={'100%'}
          size={'large'}
          tint="dark"
        >
          <LoginBlock
            onClickContinue={onClickContinue}
            onClickLogIn={onClickLogIn}
            onClickSignUp={onClickSignUp}
            size={size}
          />
        </BackgroundSection>
      )}
    </React.Fragment>
  );
};

export default Login;
